import type { TournamentFeeRow } from "./api";

export interface FeeTotals {
  accrued: number;
  pending: number;
  paid: number;
  currency: string;
}

/** Totales del panel de fees (solo lectura, se calculan sobre las filas que ya
 * trae /payments/tournament-fees): acumulado de todos los torneos; pendiente =
 * acumulado de los torneos cuyo estado de cobro es Pendiente o Facturado;
 * pagado = acumulado de los torneos en Pagado. */
export function feeTotals(rows: TournamentFeeRow[]): FeeTotals {
  let accrued = 0;
  let pending = 0;
  let paid = 0;
  for (const row of rows) {
    const amount = Number(row.accrued_platform_fee);
    if (!Number.isFinite(amount)) continue;
    accrued += amount;
    if (row.admin_fee_status === "pending" || row.admin_fee_status === "invoiced") pending += amount;
    if (row.admin_fee_status === "paid") paid += amount;
  }
  return { accrued, pending, paid, currency: rows[0]?.currency ?? "MXN" };
}
